import React from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system';
import IconLineChart from 'design-system/icons/IconLineChart';
import { SettingsItemSwitch } from 'design-system/SettingsItem';
import Modal from 'utils/packages/Modal';
const strings = {
    title: 'Credit report settings',
    trackDebts: {
        title: 'Track your debts in net worth',
        description: 'Automatically import loan and mortgage balances from your credit report',
    },
};
const CreditReportSettingsModalContent = ({ isTrackingDebts, onToggleTrackingDebts, }) => (<SettingsItemSwitch title={strings.trackDebts.title} description={strings.trackDebts.description} icon={<IconLineChart />} style={styles.switch} value={isTrackingDebts} onValueChange={(value) => Modal.hide(() => onToggleTrackingDebts(value))}/>);
const CreditReportSettingsModal = {
    show: (props) => {
        Modal.show(<CreditReportSettingsModalContent {...props}/>, {
            title: strings.title,
        });
    },
    hide: Modal.hide,
};
const styles = StyleSheet.create({
    switch: {
        margin: 0,
        paddingTop: rem(24),
        paddingBottom: rem(16),
    },
});
export default CreditReportSettingsModal;
